enum ListNameEnum {
    FAVORITES = "Favorites",
    RECOMMENDATIONS = "Recommendations"
}

export default ListNameEnum;
